import React from "react";
import "../../styles/module/blog.css";

import bg2 from "../../assets/images/img/bg-2.webp";
import arrow from "../../assets/images/img/downarrow.webp";
import bg3 from "../../assets/images/img/bg-3.svg";

export default function TermsOfUse() {
  return (
    <>
      <div className="main-wrapper">
        <img
          alt="scrollDown"
          src={bg2}
          className=" landing__image-background-2 image-background"
        />
        <div className="rotated-text" onClick={() => window.location.href = '#scroll'}>
          <img
            src={arrow}
            alt="downarrow"
            className=""
          />
          <h4>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>{' '}scroll down</font>
            </font>
          </h4>
        </div>
        <div className="section">
          <img
            className="landing__image-background-1 image-background"
            src={bg3}
            alt="container background"
          />
          <div className="container blog-post single-page">
            <div id="scroll" className="content">
              <h5>Terms & Conditions</h5>
              <h2>
                We set clear rules for using our app or website to ensure a safe
                and fair experience for everyone, defining both your
                responsibilities and our rights.
              </h2>
              <h6>1. Acceptance of Terms</h6>
              <ol>
                <li>
                  By accessing or using any services provided by Genvix Tech,
                  including our websites, mobile applications, and related
                  platforms ("Services"), you agree to be legally bound by these
                  Terms & Conditions. If you do not agree to these terms, you
                  must not use our Services.
                </li>
              </ol>
              <h6>2. Modifications to Terms</h6>
              <ol>
                <li>
                  Genvix Tech reserves the right to revise these Terms &
                  Conditions at any time. Any changes will be effective
                  immediately upon posting. Your continued use of the Services
                  following such changes constitutes your acceptance of the
                  revised terms. We recommend reviewing this page periodically.
                </li>
              </ol>
              <h6>3. Use of Services</h6>
              <ol>
                The Services are provided for your personal, lawful, and
                non-commercial use only. You agree not to use the Services:
                <li>For any unlawful purpose or activity.</li>
                <li>
                  In violation of any local, national, or international law or
                  regulation.
                </li>
                <li>
                  To infringe upon or violate our intellectual property rights
                  or the rights of others.
                </li>
                <li>
                  To transmit any malicious software or attempt to gain
                  unauthorized access to any system.
                </li>
                <div style={{ marginTop: "-35px" }}>
                  We reserve the right to restrict, suspend, or terminate access
                  to the Services for any user who violates these terms.
                </div>
              </ol>
              <h6>4. User-Generated Content</h6>
              <ol>
                By submitting content through any Genvix Tech service, you grant
                us a non-exclusive, worldwide, royalty-free, irrevocable, and
                perpetual license to use, reproduce, modify, adapt, publish,
                translate, distribute, and display such content.
                <br />
                You represent and warrant that:
                <li>
                  You own or control all rights to the content you submit.
                </li>
                <li>
                  Your content does not violate any laws or rights of third
                  parties.
                  <br />
                  Genvix Tech disclaims any liability related to user-submitted
                  content and is under no obligation to review or monitor such
                  content.
                </li>
              </ol>
              <h6>5. Termination</h6>
              <ol>
                <li>
                  Genvix Tech may suspend or terminate your access to the
                  Services, without notice or liability, for any reason,
                  including but not limited to a breach of these Terms &
                  Conditions.
                </li>
              </ol>
              <h6>6. Disclaimer of Warranties</h6>
              <ol>
                <li>
                  The Services are provided on an "as is" and "as available"
                  basis. Genvix Tech makes no warranties, express or implied,
                  including but not limited to warranties of merchantability,
                  fitness for a particular purpose, non-infringement, or
                  availability.
                </li>
              </ol>
              <h6>7. Limitation of Liability</h6>
              <ol>
                <li>
                  To the fullest extent permitted by law, Genvix Tech shall not
                  be liable for any damages arising out of or related to the use
                  or inability to use our Services. This includes, but is not
                  limited to, direct, indirect, incidental, special, punitive,
                  or consequential damages.
                </li>
              </ol>
              <h6>8. Indemnification</h6>
              <ol>
                You agree to indemnify, defend, and hold harmless Genvix Tech,
                its affiliates, directors, officers, employees, and agents from
                and against any claims, liabilities, damages, losses, or
                expenses (including legal fees) arising out of:
                <li>Your use of the Services.</li>
                <li>Your violation of these Terms & Conditions.</li>
                <li>
                  Your violation of any rights of another person or entity.
                </li>
              </ol>
              <h6>9. Governing Law</h6>
              <ol>
                <li>
                  These Terms & Conditions shall be governed by and construed in
                  accordance with the laws of Nepal, without regard to its
                  conflict of law principles. Any disputes arising from or
                  relating to these terms shall be subject to the exclusive
                  jurisdiction of the courts in Nepal.
                </li>
              </ol>
              <h6>10. Severability</h6>
              <ol>
                <li>
                  If any provision of these Terms & Conditions is deemed invalid
                  or unenforceable by a court of competent jurisdiction, the
                  remaining provisions shall remain in full force and effect.
                </li>
              </ol>
              <h6>11. Entire Agreement</h6>
              <ol>
                <li>
                  These Terms & Conditions constitute the entire agreement
                  between you and Genvix Tech concerning your use of the
                  Services and supersede any prior agreements or understandings,
                  whether oral or written.
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div id="about" className="section section__about__blog">
        <div className="container">
        </div>
      </div>
    </>
  );
}
